import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {joinWithLastWord, getPlural} from "../../../utils/formatString";
import {config} from "../../../constant";
import {getOrdinal} from '../../../utils/formatNumber';

export default function DialogViewArchive({open, onClose, archiveId}) {
    const [archive, setArchive] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (archiveId) {
            fetch(`${config.BASE_URL}/archives/${archiveId}`)
                .then(response => response.json())
                .then(data => {
                    setArchive(data);
                })
                .catch((error) => {
                    const message = 'Erreur dans la récupération de l\'archive';
                    console.error(message, error);
                    navigate("/error", {state: {message: message}});
                });
        }
    }, []);

    const displayFirst = () => {
        const first = archive.archiveRanks.find(archiveRank => archiveRank.position === 1);
        return (
            <Box>
                {joinWithLastWord(first.people.map(person => person.firstName), ', ', 'et')} ({getPlural(first.nbAwards, 'récompense')})
            </Box>
        );
    };

    return (
        <>
            {archive && (
                <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth>
                    <DialogTitle>Archive</DialogTitle>
                    <DialogContent>
                        <Box>
                            Année : {archive.year}
                        </Box>

                        {/* Récompenses */}
                        {archive.archiveAwards.map(archiveAward => (
                            <Box key={archiveAward.id}>
                                <h4 style={{marginBottom: 5}}>Vainqueur de la catégorie {archiveAward.archiveCategory.name}</h4>
                                {joinWithLastWord(archiveAward.winners.map(winner => winner.firstName), ', ', 'et')}<br />
                                <em>Raison : {archiveAward.reason}</em>
                            </Box>
                        ))}

                        {/* Classement */}
                        <Box>
                            <h4 style={{marginBottom: 5}}>Losers de l'année</h4>
                            {displayFirst()}
                            <ul>
                                {archive.archiveRanks
                                    .sort((r1, r2) => r1.position - r2.position)
                                    .map(archiveRank => (
                                    (archiveRank.position !== 1) && (
                                        <li key={archiveRank.id} style={{marginLeft: '1rem'}}>
                                            {getOrdinal(archiveRank.position)} : {joinWithLastWord(archiveRank.people.map(person => person.firstName), ', ', 'et')} ({getPlural(archiveRank.nbAwards, 'récompense')})
                                        </li>
                                    )
                                ))}
                            </ul>
                        </Box>

                        {/* Rapports */}
                        <Box>
                            <h4 style={{marginBottom: 5}}>Rapport de mi-saison</h4>
                            {archive.midReport && (
                                <div className="content" dangerouslySetInnerHTML={{__html: archive.midReport.replace(/\n/g, "<br />")}}></div>
                            )}
                        </Box>

                        <Box>
                            <h4 style={{marginBottom: 5}}>Rapport</h4>
                            {archive.report && (
                                <div className="content" dangerouslySetInnerHTML={{__html: archive.report.replace(/\n/g, "<br />")}}></div>
                            )}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>OK</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
